import { ThemeProvider } from '@emotion/react';
import Box from '@mui/material/Box';
import { createTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import BigNormalButton from 'components/atoms/Button/BigNormalButton';
import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import 'swiper/css';
import 'swiper/css/pagination';
import useStyles from './All.styles';

const colortheme = createTheme({
  palette: {
    primary: {
      main: '#292739',
    },
  },
  typography: {
    fontFamily: ['lato'].join(','),
  },
});

interface IEarnProps {
  loading?: boolean;
}

const Earn: React.FC<IEarnProps> = ({ loading }) => {
  const illustration = require('assets/Board/illustration_4.png');
  const header = require('assets/header.png');

  const classes = useStyles();
  const history = useNavigate();

  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <Box
          style={{
            position: 'absolute',
          }}
        >
          <img
            src={header}
            alt={'img'}
            style={{ height: '330px', width: '100%' }}
          />
        </Box>
        <Box className={classes.body}>
          <Box
            className={classes.illustrationSection}
            style={{ marginBottom: '130px' }}
          >
            <img src={illustration} alt={'img'} />
          </Box>
          <Box className={classes.titleTextSection}>
            <Typography className={classes.titleText}>
              Create content, and earn money through NFTs
            </Typography>
          </Box>
          <Typography className={classes.detailText}>
            Create content as NFTs. Discover, explore, bid, collect, or simply
            just create content as you would on other platforms. Except with the
            added benefit of being able to make money!
          </Typography>
          <Box className={classes.groupButtonSection}>
            <div
              onClick={() => !loading && history('/create/nft')}
              style={{ height: '60px' }}
            >
              <BigNormalButton
                color={'yellow'}
                text={'Create your first NFT'}
                disabled={loading}
              />
            </div>
            <div
              onClick={() => !loading && history('/explore/otr')}
              style={{ height: '60px' }}
            >
              <BigNormalButton
                color={'gray'}
                text={'Not now'}
                disabled={loading}
              />
            </div>
          </Box>
        </Box>
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Earn;
